import { createAction } from 'redux-actions';

export const getCropsPerformanceStarted = createAction('GET_CROPS_PERFORMANCE_STARTED');
export const getCropsPerformanceSucceeded = createAction('GET_CROPS_PERFORMANCE_SUCCEEDED');
export const getCropsPerformanceFailed = createAction('GET_CROPS_PERFORMANCE_FAILED');
export const getCropsPerformanceEnded = createAction('GET_CROPS_PERFORMANCE_ENDED');
export const updateCropsPerformanceSorting = createAction('UPDATE_CROPS_PERFORMANCE_SORTING');
